import styled, { css, keyframes } from "styled-components/macro"

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Container = styled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 100%;

  & * {
    box-sizing: border-box;
  }
`

export const Circle = styled.div<{ variant: "circle-1" | "circle-2" }>`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(80px / 10) solid transparent;

  ${({ variant, theme }) =>
    variant === "circle-1"
      ? css`
        border-top-color: ${theme.colors.primaryLight};
        animation: ${spin} 1s infinite linear;
      `
      : css`
        border-bottom-color: ${theme.colors.primaryLight};
        animation: ${spin} 1s infinite linear;
      `}
`

